<template>
    <div id='listing-wrapper'>
        <div v-bind:style="{ backgroundColor: color}" >
            <div style="padding-top:2px; padding-bottom: 40px">
            <span
                style="display: table; width: 100%; color: #3498db; text-align: center"
                class='not-found container'>
                <div class="row justify-content-md-center justify-content-center">
                <div class="col-md-3 col-4 text-center notfound">
                    <img :src="staticImg+'notfound.png'" alt="404 Not Found"/>
                </div>
                </div>
                <h3 class="headerTwo">We can't seem to find the page you are looking for</h3>
            </span>
            </div>
        </div>
        <h4 class='mx-2 people-may-like-txt mt-4'>You may also like:-</h4>
        <div class="container w-100 p-2">
          <div class="row pro-list">
            <div v-for="(prm, index) in noProductListData" class="col-lg-3 col-md-6 col-6" :key="prm.id + index">
            <img-block
                  :parry="prm.images !== []? prm.imageUrl: []"
                  :position="index" :isExclusive="isExclusive" :imageH="400" :imageW="300"
                  @click.native="crossSellEventHandler(prm)"
                  :index="index" :urlKey="prm.product_slug" :productTitle="prm.product" :productCat="prm.artistname"
                  :productPrice="prm.price" :exclusivePrice="prm.exclusive_price" :jitValue="prm.jitValue"
                  :pstock="prm.stock" :spprice="prm.splPrice || prm.spl_price" :listCat="prm.category" :genderType="prm.genderType"
                  :pclass="'prd'+prm.id+ prm.category +'img'" :product="prm" :isStockConfig="prm.prodQty"
                  :prodType="prm.prodType" :imageCount="noProductListData.length" :showImageBlurSoldOutDesign="true" :callerComp="'No Product Found'"
                  :wishlistItemsIDs="wishlistItemsIDs" :updateWishlist="updateWishlist" :prm="prm"
                >
                </img-block>
            </div>
            <div v-if="loading" class='mt40 mb20 row w-full justify-content-center align-items-center load-more-loader'>
              <img :src="staticImgServer + 'assets/spinner-3.gif'" class='spinner-3' alt="Loader"/>
            </div>
             <div v-if="infiniteScrollError" class='mt20 mb20 row w-full justify-content-center align-items-center'>
                <span class="fbold" style="color: #ed2d2f;">OOPS ! Something went Wrong, Please try Again</span>
              </div>
            </div>
        </div>
    </div>
</template>

<script>
import {mapGetters} from 'vuex'
import imgBlock from './imgBlock.vue'
import webPush from '@/assets/js/webPushNotification'
import {getProductUrl} from '../../assets/js/common'
import {wrapperBottomVisible} from '../../assets/js/appMixins'
export default {
  data () {
    return {
      staticImg: process.env.STATIC_IMG,
      color: '#f7f7f7',
      currentpg: this.$store.getters.getSearchPageNo,
      staticImgServer: process.env.STATIC_IMG_SERVER2,
      pgsNumb: 30,
      isBottomVisible: false,
      searchList: {data: {}, total: ''},
      mobileCurrentPage: 1,
      loading: false,
      infiniteScrollError: false,
      noProductListData: [],
      pagination: {
        currentPage: 0,
        totalPages: null,
        productsOffset: 30
      }
    }
  },
  components: {imgBlock},
  mixins: [wrapperBottomVisible],
  computed: {
    ...mapGetters(
      ['noProductDataList', 'isExclusive', 'wishlistItemsIDs', 'webpushInitiator']
    ),
    productsListing: function () {
      return this.noProductDataList
    },
    getTotalPages () {
      return this.noProductDataList && this.noProductDataList.numberOfProducts && Math.ceil(this.noProductDataList.numberOfProducts / this.pagination.productsOffset)
    },
    active_pricelists: function () {
      if (this.$store.getters.active_pricelists['pricelists']) {
        if (this.$store.getters.active_pricelists['pricelists'].length > 0) {
          return this.$store.getters.active_pricelists['pricelists']
        }
      }
    }
  },
  methods: {
    scrollToUpVisibile () {
      const listingWrapperEl = document.getElementById('listing-wrapper')
      if (listingWrapperEl) {
        const scrollY = window.scrollY
        return scrollY >= listingWrapperEl.scrollHeight / 5
      }
    },
    captureScroll: function () {
      if (this.productsListing && this.productsListing.products && this.productsListing.products.length) {
        this.isBottomVisible = this.wrapperBottomVisible('listing-wrapper')
      }
    },
    getProductUrl,
    crossSellEventHandler (prm) {
      this.$store.dispatch('TATVIC_EVENT', {eventName: 'NO_PRODUCT_FOUND_LIST',
        payload: {
          PRODUCT_NAME: prm.product,
          PRODUCT_CATEGORY: prm.category,
          PARENT_SKU: prm.id
        }}
      )
      this.$store.commit('MOENGAGE_EVENT', {eventName: 'NO_PRODUCT_FOUND_LIST',
        payload: {
          Product_Category: prm.category,
          Product_Name: prm.product,
          Product_ID: prm.id,
          Product_Price: prm.splPrice || prm.spl_price || prm.exclusive_price ? this.isExclusive ? prm.exclusive_price : prm.splPrice || prm.spl_price : prm.price,
          Quantity: 1,
          Product_Artist: prm.artist,
          ProductImage_URL: this.prdImg + (prm.images && prm.images[0]),
          Product_URL: this.getProductUrl(true, prm.product_slug, prm.gender_type)
        }}
      )
    },
    updateWishlist: function (item, e) {
      if (this.wishlistItemsIDs && item && item.id) {
        const data = {
          category: item.category && item.category,
          gender_type: item.gender_type && item.gender_type.toString(),
          images: JSON.parse(item.images),
          parent_prod_id: item.id,
          price: item.price,
          prod_id: item.id,
          prod_type: item.prod_type,
          prod_qty: item.prod_qty,
          quantity: 1,
          product: item.product,
          size: '',
          prArtist: item.artist && item.artist.replace('\u0099', '') || '',
          spl_price: item.spl_price,
          url_key: item.url_key
        }
        if (this.wishlistItemsIDs[item.id]) {
          this.$store.dispatch('UPDATE_WISHLIST', {operation: 'delete', type: 'products', data}).then(() => {
            e.target.classList.add('wishlistAnimation')
            setTimeout(function () {
              e.target.classList.remove('wishlistAnimation')
            }, 1000)
          })
        } else {
          this.$store.dispatch('UPDATE_WISHLIST', {operation: 'add', type: 'products', data}).then(() => {
            e.target.classList.add('wishlistAnimation')
            setTimeout(function () {
              e.target.classList.remove('wishlistAnimation')
            }, 1000)
          })
          this.$store.dispatch('ECOMMERCE_EVENT', {eventName: 'add_to_wishlist',
            payload: {
              currency: 'INR',
              value: this.isExclusive ? item.exclusive_price : ((item.splPrice || item.spl_price) && (item.splPrice > 0 || item.spl_price > 0)) ? item.splPrice || item.spl_price : item.price,
              items: [
                {
                  item_name: data.product,
                  item_id: data.prod_id,
                  price: (this.isExclusive ? item.exclusive_price : ((item.splPrice || item.spl_price) && (item.splPrice > 0 || item.spl_price > 0)) ? item.splPrice || item.spl_price : item.price),
                  item_category: data.category,
                  discount: item.price - (this.isExclusive ? item.exclusive_price : ((item.splPrice || item.spl_price) && (item.splPrice > 0 || item.spl_price > 0)) ? item.splPrice || item.spl_price : item.price),
                  quantity: data.quantity,
                  currency: 'INR',
                  item_category2: data.size || 'NA',
                  item_brand: 'The Souled Store'
                }
              ]
            }
          })
          if (this.webpushInitiator) {
            webPush.webpushSubscription().then(() => {
              this.$store.commit('WEBPUSH_INITIATOR', false)
            })
          }
        }
      } else {
        this.$router.push(`/login?redirect=${this.$route.path}`)
      }
    },
    loadProducts (pageCount) {
      this.$store.dispatch('GET_NO_PRODUCT_DATA_LIST', {
        page: pageCount || this.pagination.currentPage,
        offset: this.pagination.productsOffset,
        is_exclusive: this.isExclusive ? 1 : 0
      }).then((res) => {
        if (res && res.products.length) {
          this.pagination.currentPage = pageCount || 0
          pageCount && pageCount > 1 ? this.loading = false : ''
          this.infiniteScrollError = false
          this.$store.commit('SET_NO_PRODUCT_DATA_LIST', res)
          this.$store.commit('MOENGAGE_EVENT', {eventName: 'NO_PRODUCT_FOUND_LIST_404',
            payload: {
              Product_URL: this.getProductUrl(true)
            }}
          )
        }
      }).catch(() => {
        this.infiniteScrollError = true
      })
    }
  },
  created () {
    this.loadProducts()
  },
  mounted () {
    window.addEventListener('scroll', this.captureScroll)
  },
  beforeDestroy () {
    this.$store.commit('SET_NOT_FOUND_FALSE')
  },
  watch: {
    isBottomVisible (bottom) {
      if (bottom && this.pagination && this.pagination.currentPage < this.getTotalPages) {
        const currentPage = this.pagination.currentPage + 1
        this.loading = true
        this.infiniteScrollError = false
        this.loadProducts(currentPage)
      }
    },
    noProductDataList (response) {
      if (this.pagination.currentPage === 0) {
        this.noProductListData = [...response.products]
      } else {
        this.noProductListData = [...this.noProductListData, ...response.products]
      }
      for (var i = 0; i < this.noProductListData.length; i++) {
        let item = this.noProductListData[i]
        this.noProductListData[i]['discounted_price'] = item['spl_price']
        this.noProductListData[i]['exclusive_price'] = JSON.parse(item['exclusive_pricelist'])['price']
        if (this.active_pricelists && item['exclusive_pricelist']) {
          this.noProductListData[i]['discounted_price'] = this.noProductListData[i]['exclusive_price']
        }
      }
    }
  }
}
</script>

<style scoped>
    .wishlistAnimation {
      animation: mymove 1s;
    }
    .not-found {
      margin-left: auto;
      margin-right: auto;
      margin-bottom: 10px;
      margin-top: 50px;
    }
    .notfound img{
        height: 150px;
    }
    .headerOne {
      font-size: 6em;
      margin-left: auto;
      margin-right: auto;
      padding: 50px;
    }
    .center {
      margin-left: auto;
      margin-right: auto;
      margin-top: 5%;
      max-width: 30%;
      height: 50px;
      font-size: 1.5em;
    }
    .headerTwo {
      color: #aaa;
    }
    @media screen and (max-width: 991px) {
      .not-found {
        margin-left: auto;
        margin-right: auto;
        margin-bottom: 10px;
        margin-top: 70px;
      }
      .headerOne {
        margin-left: auto;
        margin-right: auto;
        padding: 20px;
        font-size: 4em;
      }
      .headerTwo {
        max-width: 90%;
        font-size: 1.8em;
        margin-left: auto;
        margin-right: auto;
      }
      .center {
        font-size: 1.5em;
        margin-left: auto;
        margin-right: auto;
        height: 50px;
        max-width: 70%;
        margin-top: 20%;
      }
      .error {
        font-size: 1.2em;
      }
    }
    @media screen and (max-width: 768px) {
      .notfound img{
        height: auto;
      }
      .not-found {
        margin-left: auto;
        margin-right: auto;
        margin-bottom: 10px;
        margin-top: 70px;
      }
      .headerOne {
        margin-left: auto;
        margin-right: auto;
        padding: 20px;
        font-size: 4em;
      }
      .headerTwo {
        max-width: 90%;
        font-size: 1.8em;
        margin-left: auto;
        margin-right: auto;
      }
      .center {
        font-size: 1.2em;
        margin-left: auto;
        margin-right: auto;
        height: 50px;
        max-width: 70%;
        margin-top: 20%;
      }
      .error {
        font-size: 1.2em;
      }
    }

</style>



// WEBPACK FOOTER //
// NoProductFoundListing.vue?5b705845